<template>
  <div class="steps-container">
    <div class="width-67">
      <ul class="steps  has-content-centered">
        <li v-for="(item, index) in steps"
            :key="index"
            class="steps-segment"
            :class="{'is-active': currentStep === item}">
          <div class="steps-marker" :class="getIconClass(item)">
            <b-icon
              v-if="getIcon(item)"
              size="is-small"
              :icon="getIcon(item)"
              custom-class="has-text-weight-bold">
            </b-icon>
          </div>
          <div class="steps-content">
            <p v-if="!$slots[item]">{{ $t(`${racineTraduction}${item}`) }}</p>
            <slot v-else :name="item"></slot>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: String,
      required: true,
    },
    racineTraduction: {
      type: String,
      default: 'detail.steps.',
    },
    icons: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    getIconClass(step) {
      return this.icons.find(i => i.step === step)?.customClassMarker ?? '';
    },
    getIcon(step) {
      return this.icons.find(i => i.step === step)?.icon;
    },
  },
};
</script>
